<nav class="navigation">
    <div class="nav-container generic-container">
        <div class="nav-content">
            <!-- Logo -->
            <a class="logo-link hover-bounce" [routerLink]="['/']">
                <div class="logo-container">
                    <img
                        src="https://funfigz-assets-public.s3.ap-south-1.amazonaws.com/product-logo.png"
                        alt="FunFigz Logo"
                        class="logo-image"
                    />
                </div>
            </a>

            <!-- Desktop Navigation -->
            <div class="desktop-nav">
                <a
                    *ngFor="let link of navLinks"
                    [routerLink]="[link.href]"
                    class="nav-link"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{
                        matrixParams: 'exact',
                        queryParams: 'ignored',
                        paths: 'exact',
                        fragment: 'ignored'
                    }"
                >
                    {{ link.label }}
                </a>
            </div>

            <!-- Desktop Search Bar -->
            <div class="search-container" appClickOutside (clickOutside)="handleClickOutside('desktop')">
                <div class="search-input-wrapper">
                    <mat-icon
                        aria-hidden="false"
                        aria-label="search icon"
                        fontIcon="search"
                        (click)="handleSearch(searchControl.value)"
                        class="search-icon"
                    ></mat-icon>

                    <input
                        #desktopSearchInput
                        type="text"
                        placeholder="Search toys..."
                        class="search-input"
                        [formControl]="searchControl"
                        (focus)="onInputFocus('desktop')"
                        (keyup.enter)="handleSearch(searchControl.value)"
                        [matAutocomplete]="auto"
                    />
                </div>

                <!-- Angular Material Autocomplete -->
                <mat-autocomplete
                    #auto="matAutocomplete"
                    class="recent-searches"
                    (optionSelected)="selectSearch($event.option.value, 'desktop')"
                >
                    <mat-option
                        *ngFor="let term of filteredSearches$ | async | slice: 0 : 5"
                        [value]="term"
                        (onSelectionChange)="handleSearch(term)"
                    >
                        {{ term }}
                    </mat-option>
                </mat-autocomplete>
            </div>

            <!-- Cart & Mobile Menu -->
            <div class="nav-actions">
                <!-- Wishlist -->
                <a [routerLink]="['/wishlist']" class="wishlist-button hover-bounce">
                    <app-button variant="ghost" size="icon">
                        <mat-icon
                            aria-hidden="false"
                            aria-label="favorite icon"
                            fontIcon="favorite_border"
                            class="custom-icon"
                        ></mat-icon>
                        <app-badge *ngIf="wishlistCount > 0" variant="count">{{ wishlistCount }}</app-badge>
                    </app-button>
                </a>

                <!-- Cart -->
                <a [routerLink]="['/checkout/cart']" class="cart-button hover-bounce">
                    <app-button variant="ghost" size="icon">
                        <mat-icon
                            aria-hidden="false"
                            aria-label="cart icon"
                            fontIcon="shopping_cart"
                            class="custom-icon material-icons-outlined"
                        ></mat-icon>
                        <app-badge *ngIf="cartCount > 0" variant="count">
                            {{ cartCount }}
                        </app-badge>
                    </app-button>
                </a>

                <!-- Profile Avatar Container -->
                <div class="profile-avatar-container" appClickOutside (clickOutside)="isProfileSidebarOpen = false">
                    <!-- Profile Avatar -->
                    <a class="profile-avatar hover-bounce" *ngIf="!isUserLogin" (click)="loginDialog()">
                        <app-button variant="ghost" size="icon">
                            <mat-icon>person</mat-icon>
                        </app-button>
                    </a>

                    <span *ngIf="isUserLogin">
                        <a
                            class="profile-avatar hover-bounce"
                            (click)="toggleProfileSidebar()"
                            *ngIf="userDetails?.user?.profileImage; else noImage"
                        >
                            <img [src]="userDetails?.user?.profileImage" alt="Profile" />
                        </a>
                        <ng-template #noImage>
                            <a (click)="toggleProfileSidebar()">
                                <app-button variant="ghost" size="icon">
                                    <mat-icon class="no-image-icon hover-bounce">account_circle</mat-icon>
                                </app-button>
                            </a>
                        </ng-template>
                    </span>

                    <!-- User Actions -->
                    <div class="user-actions" [class.open]="isProfileSidebarOpen">
                        <div class="user-actions-header">
                            <h3 class="welcome-text">Welcome {{ userDetails?.user?.name }}</h3>
                        </div>

                        <!-- Divider -->
                        <div class="divider"></div>

                        <div class="user-actions-links">
                            <a [routerLink]="['/account']" (click)="toggleProfileSidebar()">
                                <mat-icon> account_circle </mat-icon> Account
                            </a>
                            <a [routerLink]="['/wishlist']" (click)="toggleProfileSidebar()">
                                <mat-icon> favorite_border </mat-icon> Wishlist
                            </a>
                            <a [routerLink]="['/notifications']" (click)="toggleProfileSidebar()">
                                <mat-icon> notifications </mat-icon> Notifications
                            </a>

                            <!-- Divider -->
                            <div class="divider"></div>

                            <a (click)="onUserLogout()"> <mat-icon>logout</mat-icon> Log out </a>
                        </div>
                    </div>
                </div>

                <!-- Mobile Menu Button -->
                <app-button variant="ghost" size="icon" class="mobile-menu-button" (click)="toggleMenu()">
                    <mat-icon
                        *ngIf="!isMenuOpen"
                        aria-hidden="false"
                        aria-label="menu icon"
                        fontIcon="menu"
                        class="custom-icon"
                    ></mat-icon>
                    <mat-icon
                        *ngIf="isMenuOpen"
                        aria-hidden="false"
                        aria-label="close icon"
                        fontIcon="close"
                        class="custom-icon"
                    ></mat-icon>
                </app-button>
            </div>
        </div>

        <!-- Mobile Menu -->
        <div class="mobile-menu" *ngIf="isMenuOpen">
            <div class="mobile-menu-content">
                <a
                    *ngFor="let link of navLinks"
                    [routerLink]="[link.href]"
                    class="mobile-nav-link"
                    [class.active]="isActiveLink(link.href)"
                    (click)="closeMenu()"
                >
                    {{ link.label }}
                </a>

                <!-- Mobile Search -->
                <div class="mobile-search" appClickOutside (clickOutside)="handleClickOutside('mobile')">
                    <div class="mobile-search-input-wrapper">
                        <mat-icon
                            aria-hidden="false"
                            aria-label="search icon"
                            fontIcon="search"
                            (click)="handleSearch(searchControl.value)"
                            class="search-icon"
                        ></mat-icon>
                        <input
                            #mobileSearchInput
                            type="text"
                            placeholder="Search toys..."
                            class="mobile-search-input"
                            [formControl]="searchControl"
                            (focus)="onInputFocus('mobile')"
                            (input)="onInputChange(searchControl.value, 'mobile')"
                            (keyup.enter)="handleSearch(searchControl.value)"
                        />
                    </div>

                    <!-- Mobile Recent Searches Dropdown -->
                    <div *ngIf="searchContext === 'mobile' && (filteredSearches$ | async) as searches">
                        <div class="recent-searches" *ngIf="searches.length">
                            <div
                                *ngFor="let term of searches | slice: 0 : 5"
                                class="recent-search-item"
                                (click)="selectSearch(term, 'mobile')"
                            >
                                {{ term }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>
